const apiKey = process.env.REACT_APP_OPEN_WEATHER_KEY;

export const weatherLayers: any = {
  Clouds: {
    unit: '%',
    url: `https://tile.openweathermap.org/map/clouds_new/{z}/{x}/{y}.png?appid=${apiKey}`,
    colors: [
      'rgba(247, 247, 255, 0)',
      'rgba(251, 247, 255, 0)',
      'rgba(244, 248, 255, 0.1)',
      'rgba(240, 249, 255, 0.2)',
      'rgba(221, 250, 255, 0.4)',
      'rgba(224, 224, 224, 0.9)',
      'rgba(224, 224, 224, 0.76)',
      'rgba(228, 228, 228, 0.9)',
      'rgba(232, 232, 232, 0.9)',
      'rgb(214, 213, 213)',
      'rgb(210, 210, 210)',
      'rgb(183, 183, 183)',
    ],
    labels: [0, 25, 50, 75, 100],
  },
  Sea_Level_Pressure: {
    unit: 'hPa',
    url: `https://tile.openweathermap.org/map/precipitation_new/{z}/{x}/{y}.png?appid=${apiKey}`,
    colors: [
      'rgb(0, 115, 255)',
      'rgb(0, 170, 255)',
      'rgb(75, 208, 214)',
      'rgb(141, 231, 199)',
      'rgb(176, 247, 32)',
      'rgb(240, 184, 0)',
      'rgb(251, 85, 21)',
      'rgb(243, 54, 59)',
      'rgb(198, 0, 0)',
    ],
    labels: [950, 980, 1010, 1040, 1070],
  },
  Temperature: {
    unit: '°C',
    url: `https://tile.openweathermap.org/map/temp_new/{z}/{x}/{y}.png?appid=${apiKey}`,
    colors: [
      'rgba(130, 22, 146, 1)',
      'rgba(32, 140, 236, 1)',
      'rgba(35, 221, 221, 1)',
      'rgba(194, 255, 40, 1)',
      'rgba(255, 240, 40, 1)',
      'rgba(255, 194, 40,1)',
      'rgba(252, 128, 20, 1)',
      'rgb(252, 66, 20)',
    ],
    labels: [-40, -20, -10, 0, 10, 20, 40],
  },
  Wind_Speed: {
    unit: 'm/s',
    url: `https://tile.openweathermap.org/map/wind_new/{z}/{x}/{y}.png?appid=${apiKey}`,
    colors: [
      'rgb(158, 128, 177)',
      'rgba(116, 76, 172, 0.9)',
      'rgb(164, 123, 170)',
      'rgba(170, 128, 177, 0.84)',
      'rgba(176, 128, 177, 0.71)',
      'rgba(170, 128, 177, 0.54)',
      'rgba(170, 128, 177, 0.44)',
      'rgba(255, 255, 0, 0)',
    ],
    labels: [0, 2, 3, 6, 12, 25, 50, 100],
  },
  Precipitation: {
    unit: 'mm/h',
    url: `https://tile.openweathermap.org/map/pressure_new/{z}/{x}/{y}.png?appid=${apiKey}`,
    colors: [
      'rgb(170, 43, 195)',
      'rgb(255, 0, 146)',
      'rgb(255, 0, 100)',
      'rgb(255, 0, 0)',
      'rgb(255, 91, 0)',
      'rgb(255, 150, 0)',
      'rgb(255, 205, 0)',
      'rgb(239, 248, 0)',
      'rgb(0, 70, 0)',
      'rgb(0, 90, 0)',
      'rgb(0, 160, 0)',
      'rgb(0, 211, 0)',
      'rgb(0, 250, 100)',
      'rgba(0, 0, 0, 0)',
    ],
    labels: [0, 0.5, 1, 2, 4, 6, 7, 10, 12, 14, 16, 24, 32, 60],
  },
};

export const particleOverlays: any = {
  Wave_Direction: {
    unit: 'm',
    colorSchemes: {
      satellite: ['#ffffff', '#b3e5fc', '#4fc3f7', '#0288d1', '#01579b'], 
      vector_color: ['#01579b', '#ffd700', '#ff8c00', '#ff4500', '#cc0000'], 
      vector_white: ['#4fc3f7', '#01579b', '#ff6600', '#cc3300', '#990000'],
    },
    labels: [0, 1, 3, 5, 7],
  },
  Wind_Direction: {
    unit: 'm/s',
    colorSchemes: {
      satellite: ['rgba(158, 128, 177, 0.7)',  'rgba(170, 128, 177, 0.85)', 'rgba(255, 220, 100, 0.9)', 'rgba(255, 180, 50, 0.95)', 'rgba(255, 100, 50, 1)'],
      vector_color: ['#ba68c8', '#e1bee7', '#ffca28', '#ff7043', '#ec407a'],
      vector_white: ['#7b1fa2', '#6a1b9a', '#f57c00', '#e91e63', '#ad1457'],
    },
    labels: [0, 2, 4, 6, 8, 10, 12],
  },
};
